import {
  EXAM_EXPLANATION_ROOT,
  EXPLANATION_ROOT,
  ExplanationSchema,
  RECORDINGS,
  type SentenceExplanation,
} from '@listen-draw/shared';

const cache = new Map<string, SentenceExplanation>();
export async function loadExplanation(
  text: string,
  signal: AbortSignal,
): Promise<SentenceExplanation> {
  const saved = cache.get(text);
  if (saved) {
    cache.delete(text);
    cache.set(text, saved);
    return saved;
  }
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  const filename = Array.from(new Uint8Array(digest), (v) => v.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 20);
  const root = RECORDINGS[text]?.bank === 'en-exam1' ? EXAM_EXPLANATION_ROOT : EXPLANATION_ROOT;
  const response = await fetch(`${root}/${filename}.json`, {
    signal: AbortSignal.any([signal, AbortSignal.timeout(15000)]),
  });
  if (!response.ok) throw new Error('Explanation download failed');
  const explanation = ExplanationSchema.parse(await response.json());
  if (explanation.text !== text) throw new Error('Explanation does not match this sentence');
  cache.set(text, explanation);
  while (cache.size > 24) cache.delete(cache.keys().next().value!);
  return explanation;
}
